module.exports = __webpack_public_path__ + "img/1-lg.48503921.jpg";